import React, { useEffect, useRef, memo } from "react";
import {
  progressBarTransition,
  updateLocation,
} from "~/utils/quiz/transitions";
import { container, bar } from "./index.module.scss";

export const ProgressBar = memo(({ quizLength, step }) => {
  const barElement = useRef(null);
  let transition = progressBarTransition(quizLength, step);

  useEffect(() => {
    updateLocation();
    transition = progressBarTransition(quizLength, step + 1);
    barElement.current.style["transform"] = transition.transform;
  }, [step]);

  return (
    <div className={container}>
      <div
        ref={barElement}
        className={bar}
        style={{ ...transition }}
        data-testid="progress-bar"
      />
    </div>
  );
});

ProgressBar.displayName = "ProgressBar";
